import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import DeleteIcon from '@material-ui/icons/Delete'
import { connect } from 'react-redux'
import { eliminarCereal } from '../../../Cereal/actions'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function EliminarCereal (props) {
  const { data, eliminarCereal } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = () => {
    eliminarCereal(data.nombreCorto)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleDelete}
          title='Eliminar cereal'
          content={<DialogConfirmacionContent message='¿Esta seguro que desea eliminar el cereal seleccionado?' />}
        />
      </Dialog>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={() => handleOpen()} style={{ outline: 'none' }}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  eliminarCereal
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EliminarCereal)
